export interface CartItem {
  productId: string;
  productName: string;
  unitPrice: number;
  taxRate: number;
  quantity: number;
  subtotal: number;
  productDiscountPercentage: number; // 0-30% discount per product
  productDiscountAmount: number; // Calculated discount amount
  /** System available stock at last add (FO over-qty / Rupture indicator) */
  availableStock?: number;
  /** Arbitrary-price category line; excluded from inventory movements. */
  isFreePrice?: boolean;
  categoryId?: string;
}

export interface Cart {
  id: string;
  branchId: string; // Branch where the cart was created
  userId: string; // Cashier who created the cart
  items: CartItem[];
  discountPercentage: number;
  subtotal: number;
  discountAmount: number;
  totalAmount: number;
  customerId?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface Payment {
  method: PaymentMethod;
  amountPaid: number;
  cashGiven?: number;
  cashReturned?: number;
}

export enum PaymentMethod {
  CASH = 'CASH',
  CARD = 'CARD',
  CHEQUE = 'CHEQUE',
}

export interface Sale {
  id: string;
  receiptId: string;
  cartId: string;
  cashierId: string;
  customerId?: string;
  branchId: string;
  items: CartItem[];
  discountPercentage: number;
  subtotal: number;
  discountAmount: number;
  totalAmount: number;
  payment: Payment;
  shouldPrintReceipt: boolean;
  createdAt: Date;
}

export interface Refund {
  id: string;
  originalSaleId: string;
  originalReceiptId: string;
  cashierId: string;
  branchId: string;
  items: CartItem[];
  refundAmount: number;
  reason?: string;
  createdAt: Date;
} 